import { BaseProperties } from "./base.interface";

export enum PlanFeatureNames {
  MAX_USERS = "MAX_USERS",
  MAX_PRODUCTS = "MAX_PRODUCTS",
  MAX_TAGS = "MAX_TAGS",
  MAX_ORDERS = "MAX_ORDERS",
  MAX_CUSTOMERS = "MAX_CUSTOMERS",
  MAX_EXPANSES = "MAX_EXPANSES",
  DISPLAY_CALENDAR = "DISPLAY_CALENDAR",
  DISPLAY_DASHBOARD = "DISPLAY_DASHBOARD",
  DISPLAY_DELINQUENCY = "DISPLAY_DELINQUENCY",
  DISPLAY_MENU = "DISPLAY_MENU",
}
export interface PlansInput {
  name: string;
  description: string;
  price: number;
}

export interface PlanFeatures extends BaseProperties {
  name: PlanFeatureNames;
  displayName: string;
  displayValue: string;
  value: string;
  allowAdditional: boolean;
  additionalPrice: number;
}

export interface PlansOutput extends BaseProperties, PlansInput {
  features: PlanFeatures[];
}
